export function getDictData (dictDatas, value) {
  // 获取 dictType 对应的数据字典数组
  if (!dictDatas || dictDatas.length === 0) {
    return ''
  }
  // 获取 value 对应的展示名
  value = value + '' // 强制转换成字符串，因为 DictData 小类数值，是字符串
  for (const dictData of dictDatas) {
    if (dictData.value === value) {
      return dictData
    }
  }
  return undefined
}
export function getDictDataLabel (dictDatas, value) {
  const dict = getDictData(dictDatas, value)
  return dict ? dict.label : ''
}



// WEBPACK FOOTER //
// ./src/utils/dict.js